module.exports = __webpack_public_path__ + "img/720-banner.efb2e9f1.png";